import { Observable } from "rxjs";
import { IAppGraphModel } from "./graph.component";

export abstract class GraphBase {

  abstract get(customerNumber?: number): Observable<IAppGraphModel>;

  protected getShortMonthName(monthNumber: number, languageIso2Code: string) {
    const date = new Date();
    date.setMonth(monthNumber - 1);
    let culture = 'en-US';

    switch (languageIso2Code.toLocaleLowerCase()) {
      case 'no':
        culture = 'nb-NO';
        break;
      case 'da':
        culture = 'da-DK';
        break;
      case 'fi':
        culture = 'fi-FI'
        break;
      default:
        break;
    }
    return date.toLocaleString(culture, { month: 'short', });
  }

  protected readStyleProperty(name: string): string {
    const bodyStyles = window.getComputedStyle(document.body);
    return bodyStyles.getPropertyValue(name);
  }
}
